import { cn } from '../../lib/cn';

type Props = {
  features?: string[];
  activeCollection?: string;
};

export function CatalogExplorerPanel({ features = [], activeCollection = 'All Products' }: Props) {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-1">
        {[activeCollection, 'Smart Collections', 'Marketplace Groups', 'Brand Groups'].map((item) => (
          <button
            key={item}
            type="button"
            className={cn(
              'rounded-lg px-3 py-1.5 text-xs font-medium transition',
              item === activeCollection
                ? 'bg-brand-600 text-white'
                : 'border border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400',
            )}
          >
            {item}
          </button>
        ))}
      </div>
      {features.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {features.map((f) => (
            <span key={f} className="rounded border border-slate-200 px-2 py-0.5 text-xs dark:border-slate-700">{f}</span>
          ))}
        </div>
      )}
    </div>
  );
}
